var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1922 18.5193C18.9067 18.6691 18.9067 19.0778 19.1922 19.2277L26.6856 23.1607C26.9519 23.3005 27.2715 23.1073 27.2715 22.8065L27.2715 14.9405C27.2715 14.6397 26.9519 14.4465 26.6856 14.5863L19.1922 18.5193Z",
    stroke: "#FFF057",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19217 18.5193C8.90669 18.6691 8.9067 19.0778 9.19217 19.2277L16.6856 23.1607C16.9519 23.3005 17.2715 23.1073 17.2715 22.8065L17.2715 14.9405C17.2715 14.6397 16.9519 14.4465 16.6856 14.5863L9.19217 18.5193Z",
    stroke: "#FFF057",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 0.6,
    width: 36.2194,
    height: 36.2194,
    rx: 18.1097,
    transform: "matrix(-1 0 0 1 36.2199 0.421875)",
    stroke: "#FFF057",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevActive);
export default __webpack_public_path__ + "static/media/prev-active.dafc8863de0c2f3617b5704963bd8ba9.svg";
export { ForwardRef as ReactComponent };